import React from "react";

const JsonLd = ({ data }) => {
    React.useEffect(() => {
        if (!data) return;

        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify(data);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, [data]);

    return null;
};

export default JsonLd;